import { FeatureFlag } from "./FeatureFlags";
import { isFliptFlag } from "./FliptFlagConfig";
import { FliptService } from "./FliptService";

export class FeatureFlagsService {
  private static instance: FeatureFlagsService;
  /** @deprecated Legacy CSV-based flags. Use Flipt-backed flags via {@link FliptFlagConfig} instead. */
  featureFlags: FeatureFlag[] = [];
  private fliptService: FliptService | null = null;

  constructor(featureFlags: string) {
    this.setFeatureFlags(featureFlags);
  }

  static getInstance(): FeatureFlagsService {
    if (!FeatureFlagsService.instance) {
      FeatureFlagsService.instance = new FeatureFlagsService("");
    }
    return FeatureFlagsService.instance;
  }

  /** @deprecated Returns legacy CSV-based flags only. Use {@link isFeatureEnabled} to evaluate a flag. */
  getFeatureFlags(): FeatureFlag[] {
    return this.featureFlags;
  }

  /** @deprecated Parses and stores legacy CSV-based flags. New flags must be Flipt-backed — do not extend this. */
  setFeatureFlags(flags: string): void {
    try {
      this.featureFlags = flags
        .split(",")
        .map((flag) => flag.trim())
        .filter((flag) => flag.length > 0)
        .map((flag) => flag as FeatureFlag);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error("Failed to parse feature flags:", error);
      this.featureFlags = [];
    }
  }

  setFliptService(service: FliptService | null): void {
    this.fliptService = service;
  }

  isFeatureEnabled(flag: FeatureFlag, context?: Record<string, string>): boolean {
    if (isFliptFlag(flag)) {
      return this.fliptService?.evaluate(flag, context) ?? false;
    }
    return this.featureFlags.includes(flag);
  }
}
